import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class FinancialFilingEventQueryCriteriaClass extends BaseCriteriaModel {

  hdr_guid?: Optional<string> = Optional.empty();
  link_guid?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();

}

export class FinancialFilingEventCriteriaModelQuery {
  query = '';

  constructor(financialFilingEventCriteriaModel: FinancialFilingEventQueryCriteriaClass) {

    if (!financialFilingEventCriteriaModel) {
      return;
    }

    this.query += financialFilingEventCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += financialFilingEventCriteriaModel.link_guid.filter(x => x !== '').map(x => '&link_guid=' + x).orElse('');
    this.query += financialFilingEventCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += financialFilingEventCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');

    this.query += '&status=' + financialFilingEventCriteriaModel.status;
    this.query += '&orderBy=' + financialFilingEventCriteriaModel.orderBy;
    this.query += '&order=' + financialFilingEventCriteriaModel.order;
    this.query += '&offset=' + financialFilingEventCriteriaModel.offset + '&limit=' + financialFilingEventCriteriaModel.limit;
  }
}
